export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/bundle.a371e96dc0851a537755.worker.js");
}
